import script from "./InfoTip.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoTip.vue?vue&type=script&setup=true&lang=js"

import "./InfoTip.vue?vue&type=style&index=0&id=2028e59e&scoped=true&lang=css"

import exportComponent from "/Users/alberto/sites/newform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2028e59e"]])

export default __exports__